
import { defineComponent, defineAsyncComponent } from "vue";

export default defineComponent({
  name: "Modal",
  components: {
    CardFull: defineAsyncComponent(() => import(/* webpackPrefetch: true */ "./CardFull.vue")),
    CreateAd: defineAsyncComponent(() => import(/* webpackPrefetch: true */ "./CreateAd.vue")),
    Information: defineAsyncComponent(() => import(/* webpackPrefetch: true */ "./Information.vue")),
  },
  props: {
    modal: {
      type: Object,
      required: true,
    },
  },
  methods: {
    close: function () {
      this.$store.commit("closeModal");
    },
  },
});
